import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Link as LinkIcon } from "@mui/icons-material";
import { useState } from "react";
import Copiable from "components/ui/Copiable";

export default function ShareProjectMenuItem({ project, onClick }) {
  const [open, setOpen] = useState(false);
  const onToggle = () => {
    setOpen(!open);
    if (open) {
      onClick();
    }
  };

  const shareUrl = `${window.location.origin}/viewer/project/${project.hash}`;

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        Share Project
      </MenuItem>
      <Dialog open={open} onClose={onToggle} maxWidth="xs" fullWidth>
        <DialogTitle>Share Project</DialogTitle>
        <DialogContent sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "280px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {shareUrl}
          </Typography>
          <Copiable text={shareUrl}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              <LinkIcon sx={{ mr: 1 }} color="primary" />
              <Typography variant="text" color="primary" fontSize="12px">
                Copy Link
              </Typography>
            </Box>
          </Copiable>
        </DialogContent>
        <DialogActions>
          <Button onClick={onToggle} sx={{ fontWeight: "bold" }}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
